// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedPapers-cls1_Jyy","cls2":"RelatedPapers-cls2_Hz2 RelatedPapers-cls1_Jyy"};